import React, { useState, useEffect } from 'react';
import ApiService from '../services/api'; // Make sure path is correct
import {
    MonitorCog , SquareActivity , Tickets , Menu, X, Home, Package, FileText, Calendar, Users, BarChart3, Settings,
    Bell, Search, ChevronDown, ArrowRight, TrendingUp, TrendingDown,
    Building, Hammer, Truck, Star, AlertCircle, CheckCircle, Clock,
    DollarSign, Activity, Globe, Zap, Target, Award, Shield, LogOut,
    ChevronRight, Filter, Download, RefreshCw, MoreVertical, Plus, User,
    Edit, Trash2, Eye, Package2, Layers, Wrench, ShoppingCart, Box, Hash,
    QrCode, Scan, Database, Copy, ExternalLink, BarChart2, Grid3X3, Cable, UserCog, Calculator,
    Thermometer, Anchor, Grid, Square, Ruler, Scissors, HardHat, ArrowUp, DoorOpen, Volume2,
    Construction, Mountain, Factory, Droplets, Waves, Paintbrush2, Flame, Beaker,
    Power, Cog, Circle, Battery, Leaf, Sun, Palette, Sparkles, ShieldCheck, AlertTriangle, Folder , Receipt , Briefcase
} from 'lucide-react';
import '../Styles/products.css'; // Reusing the same CSS
import { useNavigate } from 'react-router-dom';
import MepIcon from '../assets/MEP_Solutions.png';
import architecturalIcon from '../assets/architectural_icon.png';
import civilIcon from '../assets/civil-icon.png';
import constructionIcon from '../assets/construction-icon.png';
import powerToolsIcon from '../assets/power-tools_icon.png';
import sustainableIcon from '../assets/sustainable-icon.png';
import hygienicIcon from '../assets/hygienic-icon.png';
import '../Styles/dashboard.css';

const SustainableSolutionsPage = () => {
    const [user, setUser] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [activeMenuItem, setActiveMenuItem] = useState('sustainable-solutions');
    const [currentTime, setCurrentTime] = useState(new Date());
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    const [notifications, setNotifications] = useState([]);
    const [error, setError] = useState(null);

    // Sustainable Solutions categories
    const sustainableCategories = [
        {
            id: 'gfrp-concrete-reinforcement',
            name: 'GFRP Concrete Reinforcement',
            icon: <Shield className="w-8 h-8" />,
            color: '#059669',
            description: 'Glass Fiber Reinforced Polymer concrete reinforcement solutions'
        },
        {
            id: 'clean-energy-solutions',
            name: 'Clean Energy Solutions',
            icon: <Sun className="w-8 h-8" />,
            color: '#f59e0b',
            description: 'Renewable and clean energy technology solutions'
        },
        {
            id: 'paints',
            name: 'Paints',
            icon: <Palette className="w-8 h-8" />,
            color: '#7c3aed',
            description: 'Eco-friendly and sustainable paint solutions'
        },
        {
            id: 'specialized-coating-solutions',
            name: 'Specialized Coating Solutions',
            icon: <Sparkles className="w-8 h-8" />,
            color: '#06b6d4',
            description: 'Advanced specialized coating and surface treatment solutions'
        },
        {
            id: 'oil-spill-recovery',
            name: 'Oil Spill Recovery',
            icon: <Droplets className="w-8 h-8" />,
            color: '#dc2626',
            description: 'Professional oil spill recovery and cleanup systems'
        },
        {
            id: 'oil-spill-tackle',
            name: 'Oil Spill Tackle',
            icon: <AlertTriangle className="w-8 h-8" />,
            color: '#f97316',
            description: 'Emergency oil spill response and tackle equipment'
        }
    ];

    // Fonction pour créer une notification
    const showNotification = (message, type = 'success', duration = 4000) => {
        const id = Date.now() + Math.random();
        const notification = { id, message, type, duration };
        setNotifications(prev => [...prev, notification]);
        setTimeout(() => removeNotification(id), duration);
    };

    // Fonction pour supprimer une notification
    const removeNotification = (id) => {
        setNotifications(prev => prev.filter(notif => notif.id !== id));
    };

    // Load user data on mount
    useEffect(() => {
        loadCurrentUser();
    }, []);

    // Time update effect
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    // Load user function - same as barcoding
    const loadCurrentUser = async () => {
        try {
            const syncUser = ApiService.getUserSync();
            if (syncUser) {
                setUser(syncUser);
                return;
            }

            console.log('No sync user, checking authentication...');
            const response = await ApiService.getCurrentUser();
            
            if (response.success && response.user) {
                setUser(response.user);
            } else if (response.needsLogin) {
                ApiService.clearUserData();
                navigate('/login');
            } else {
                console.log('No valid session, redirecting to login...');
                navigate('/login');
            }
        } catch (error) {
            console.error('Failed to load user:', error);
            if (!ApiService.getUserSync()) {
                navigate('/login');
            }
        }
    };

    const handleRefresh = () => {
        showNotification('Données rafraîchies!', 'success');
    };

    const handleLogout = async () => {
        try {
            await ApiService.logout();
        } catch (error) {
            console.error('Logout failed:', error);
            navigate('/login');
        }
    };

    // Filter categories based on search
    const filteredCategories = sustainableCategories.filter(category => {
        const matchesSearch = category.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                             category.description.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesSearch;
    });

    // Handle category click - navigate to respective page
    const handleCategoryClick = (categoryId) => {
        console.log(`🔍 Navigating to category: ${categoryId}`);
        showNotification(`Navigation vers ${categoryId}`, 'info');
        
        // Navigate to the specific category page
        switch (categoryId) {
            case 'gfrp-concrete-reinforcement':
                navigate('/gfrp_quality_reinforcement');
                break;
            case 'clean-energy-solutions':
                navigate('/clean_energy_solutions');
                break;
            case 'paints':
                navigate('/paints_page');
                break;
            case 'specialized-coating-solutions':
                navigate('/specailized_coating_solutions');
                break;
            case 'oil-spill-recovery':
                navigate('/oil_spill_recovery');
                break;
            case 'oil-spill-tackle':
                navigate('/oil_spill_tackle');
                break;
            default:
                showNotification('Page non trouvée', 'error');
                break;
        }
    };


const menuItems = [
    { 
        id: 'barcoding', 
        label: 'Barcoding Database', 
        icon: FileText, // Keep as Lucide icon
        path: '/barcoding' 
    },
    { 
        id: 'mep-solutions', 
        label: 'MEP Solutions', 
        icon: MepIcon, // 🔄 Replace with image
        isImage: true,
        path: '/mep_solutions' 
    },
    { 
        id: 'architectural-solutions', 
        label: 'Architectural Solutions', 
        icon: architecturalIcon , // 🔄 Replace with image
        isImage: true,
        path: '/architectural_solutions' 
    },
    { 
        id: 'civil-solutions', 
        label: 'Civil Solutions', 
        icon: civilIcon, // 🔄 Replace with image
        isImage: true,
        path: '/civil_solutions' 
    },
    { 
        id: 'construction-chemicals', 
        label: 'Construction Chemicals', 
        icon: constructionIcon, // 🔄 Replace with image
        isImage: true,
        path: '/construction_chemicals' 
    },
    { 
        id: 'power-tools', 
        label: 'Power & Industrial Tools', 
        icon: powerToolsIcon, // 🔄 Replace with image
        isImage: true,
        path: '/power_tools' 
    },
    { 
        id: 'sustainable-solutions', 
        label: 'Sustainable Solutions', 
        icon: sustainableIcon, // 🔄 Replace with image
        isImage: true,
        path: '/sustainable_solutions' 
    },
    { 
        id: 'hygienic-solutions', 
        label: 'Hygienic Solutions', 
        icon: hygienicIcon, // 🔄 Replace with image
        isImage: true,
        path: '/hygienic_solutions' 
    },
    { 
        id: 'conversions', 
        label: 'Engineering Conversions', 
        icon: Calculator, // Keep as Lucide icon
        path: '/conversion' 
    },
    { 
        id: 'analytics', 
        label: 'Amazon Products', 
        icon: BarChart3, // Keep as Lucide icon
        path: '/amazon_products' 
    },
    { 
        id: 'team', 
        label: 'Team Management', 
        icon: Users, // Keep as Lucide icon
        path: '/team_management' 
    },
    { 
        id: 'user-management', 
        label: 'User Management', 
        icon: UserCog, // Keep as Lucide icon
        path: '/users_management' 
    },
];

    const filteredMenuItems = menuItems.filter(item => {
        if (item.id === 'team' && user?.role === 'user') return false;
        if (item.id === 'settings' && user?.role !== 'admin') return false;
        return true;
    });

    const getUserInitials = () => {
        if (!user) return 'U';
        const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
        const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
        return firstInitial + lastInitial || user.email.charAt(0).toUpperCase();
    };

    const getDisplayName = () => {
        if (!user) return 'Utilisateur';
        if (user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        return user.email;
    };

    if (!user) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                flexDirection: 'column'
            }}>
                <RefreshCw style={{ width: '24px', height: '24px', animation: 'spin 1s linear infinite' }} />
                <p style={{ marginTop: '16px' }}>Chargement...</p>
            </div>
        );
    };

    const NotificationItem = ({ notification, onRemove }) => {
        const getNotificationStyle = (type) => {
            const baseStyle = {
                padding: '16px 20px',
                borderRadius: '12px',
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)',
                border: '1px solid',
                minWidth: '350px',
                maxWidth: '500px',
                position: 'relative',
                animation: 'slideInRight 0.3s ease-out',
                cursor: 'pointer'
            };

            const styles = {
                success: { ...baseStyle, backgroundColor: '#f0fdf4', borderColor: '#bbf7d0', color: '#166534' },
                error: { ...baseStyle, backgroundColor: '#fef2f2', borderColor: '#fecaca', color: '#dc2626' },
                warning: { ...baseStyle, backgroundColor: '#fffbeb', borderColor: '#fed7aa', color: '#d97706' },
                info: { ...baseStyle, backgroundColor: '#eff6ff', borderColor: '#bfdbfe', color: '#1d4ed8' }
            };

            return styles[type] || styles.info;
        };

        const getIcon = (type) => {
            const iconStyle = { width: '20px', height: '20px' };
            switch (type) {
                case 'success': return <CheckCircle style={iconStyle} />;
                case 'error': return <AlertCircle style={iconStyle} />;
                case 'warning': return <AlertCircle style={iconStyle} />;
                default: return <Bell style={iconStyle} />;
            }
        };

        return (
            <div 
                style={getNotificationStyle(notification.type)}
                onClick={() => onRemove(notification.id)}
            >
                {getIcon(notification.type)}
                <div style={{ flex: 1 }}>
                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                        {notification.message}
                    </p>
                </div>
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove(notification.id);
                    }}
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '4px',
                        borderRadius: '4px',
                        opacity: 0.7
                    }}
                >
                    <X style={{ width: '16px', height: '16px' }} />
                </button>
            </div>
        );
    };

    return (
        <div className="dashboard-container">
            {/* Sidebar - Exact same structure */}
            <aside className="sidebar">
                    <div className="sidebar-header">
                        <div 
                            className="sidebar-logo-container"
                            onClick={() => navigate('/dashboard')}
                            style={{
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                borderRadius: '8px',
                                padding: '8px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                                e.currentTarget.style.transform = 'scale(1.02)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                                e.currentTarget.style.transform = 'scale(1)';
                            }}
                            title="Retour au Dashboard"
                        >
                            <div className="sidebar-logo">
                                <Building style={{ width: '24px', height: '24px', color: 'white' }} />
                            </div>
                            <div className="sidebar-brand">
                                <h1 className="sidebar-title">UNITECH IKK</h1>
                                <p className="sidebar-subtitle">Enterprise Dashboard</p>
                            </div>
                        </div>
                    </div>

<nav className="sidebar-nav">
  {filteredMenuItems.map((item) => (
    <div
      key={item.id}
      className={`nav-item ${activeMenuItem === item.id ? 'active' : ''}`}
      onClick={() => {
        setActiveMenuItem(item.id);
        navigate(item.path);
      }}
    >
      {item.isImage ? (
        <img 
          src={item.icon} 
          alt={item.label}
          className="nav-icon-image"
          style={{ 
            width: '20px', 
            height: '20px',
            display: 'block' // Ensures proper alignment
          }}
        />
      ) : (
        <item.icon 
          style={{ 
            width: '20px', 
            height: '20px',
            display: 'block' // Ensures consistency with images
          }} 
        />
      )}
      <span className="nav-text">{item.label}</span>
    </div>
  ))}
</nav>

                <div className="sidebar-footer">
                    <div className="user-profile">
                        <div className="user-avatar">{getUserInitials()}</div>
                        <div className="user-info">
                            <p className="user-name">{getDisplayName()}</p>
                            <p className="user-role">{user?.role || 'Utilisateur'}</p>
                        </div>
                        <button
                            className="logout-button"
                            onClick={handleLogout}
                            title="Se déconnecter"
                        >
                            <LogOut style={{ width: '16px', height: '16px' }} />
                        </button>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="main-content">
                {/* Header - Exact same structure */}
                <header className="header">
                    <div className="header-content">
                        <div className="header-left">
                            <button
                                className="menu-toggle"
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                            >
                                {sidebarOpen ?
                                    <X style={{ width: '20px', height: '20px' }} /> :
                                    <Menu style={{ width: '20px', height: '20px' }} />
                                }
                            </button>

                            <nav className="breadcrumb">
                                <div className="breadcrumb-item">
                                    <Home style={{ width: '16px', height: '16px' }} />
                                    <span>Dashboard</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <Leaf style={{ width: '16px', height: '16px' }} />
                                    <span>Sustainable Solutions</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <span>Categories</span>
                                </div>
                            </nav>
                        </div>
                    <div className="header-right">
                        <div className="search-container">
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Rechercher..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <Search className="search-icon" style={{ width: '18px', height: '18px' }} />
                        </div>

                        <div className="header-actions">
                            <button
                                className="header-button"
                                onClick={handleRefresh}
                                disabled={isLoading}
                                title="Actualiser"
                            >
                                <RefreshCw style={{
                                    width: '18px',
                                    height: '18px',
                                    transform: isLoading ? 'rotate(360deg)' : 'none',
                                    transition: 'transform 1s linear'
                                }} />
                            </button>

                            <button 
                                className="header-button"
                                title="Notifications"
                            >
                                <Bell style={{ width: '18px', height: '18px' }} />
                                {notifications.length > 0 && (
                                    <span className="notification-badge">{notifications.length}</span>
                                )}
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/settings')}
                                title="Paramètres système"
                            >
                                <Settings style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/project_management')}
                                title="Gestion de projets"
                            >
                                <Folder style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/technical_support')}
                                title="Technical Support"
                            >
                                <MonitorCog style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/admin_support_it')}
                                title="Admin Support IT"
                            >
                                <SquareActivity style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/mytickets')}
                                title="My Tickets"
                            >
                                <Tickets style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/quotations')}
                                title="Quotation System"
                            >
                                <Receipt style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/clients')}
                                title="Clients"
                            >
                                <Briefcase style={{ width: '18px', height: '18px' }} />
                            </button>

                            <div className="time-display">
                                {currentTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                            </div>
                        </div>
                    </div>
                    </div>
                </header>

                {/* Sustainable Solutions Content */}
                <div className="products-content">
                    {/* Error Display */}
                    {error && (
                        <div className="error-message" style={{
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            padding: '12px',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                            {error}
                        </div>
                    )}

                    {/* Page Header */}
                    <div className="page-header">
                        <h1 className="page-title">Solutions Durables</h1>
                        <p className="page-subtitle">
                            Gérez et explorez toutes vos solutions durables et écologiques par catégorie.
                        </p>

                        <div className="page-actions">
                            <button className="action-button">
                                <Leaf style={{ width: '16px', height: '16px' }} />
                                Ajouter Catégorie
                            </button>
                            <button className="action-button secondary">
                                <Download style={{ width: '16px', height: '16px' }} />
                                Exporter
                            </button>
                            <button className="action-button secondary">
                                <BarChart2 style={{ width: '16px', height: '16px' }} />
                                Rapport
                            </button>
                        </div>
                    </div>

                    {/* Sustainable Categories Grid */}
                    <div className="products-table-section">
                        <div className="table-header">
                            <h2 className="table-title">Catégories Durables</h2>
                            <span className="table-stats">
                                {filteredCategories.length} catégorie{filteredCategories.length > 1 ? 's' : ''} trouvée{filteredCategories.length > 1 ? 's' : ''}
                            </span>
                        </div>

                        {/* Categories Grid */}
                        <div style={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))', 
                            gap: '24px', 
                            padding: '20px 0' 
                        }}>
                            {filteredCategories.map((category) => (
                                <div
                                    key={category.id}
                                    onClick={() => handleCategoryClick(category.id)}
                                    style={{
                                        backgroundColor: 'white',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        border: '1px solid #e5e7eb'
                                    }}
                                    className="category-card-hover"
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
                                    }}
                                >
                                    {/* Card Header with Icon */}
                                    <div style={{
                                        padding: '20px',
                                        backgroundColor: category.color,
                                        color: 'white',
                                        position: 'relative',
                                        overflow: 'hidden'
                                    }}>
                                        <div style={{
                                            position: 'absolute',
                                            top: '0',
                                            right: '0',
                                            width: '80px',
                                            height: '80px',
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: '50%',
                                            transform: 'translate(25%, -25%)'
                                        }} />
                                        <div style={{
                                            position: 'absolute',
                                            bottom: '0',
                                            left: '0',
                                            width: '60px',
                                            height: '60px',
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: '50%',
                                            transform: 'translate(-25%, 25%)'
                                        }} />
                                        
                                        <div style={{
                                            position: 'relative',
                                            zIndex: 10,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}>
                                            <div style={{ flex: 1 }}>
                                                <h3 style={{
                                                    margin: '0 0 8px 0',
                                                    fontSize: '18px',
                                                    fontWeight: '600',
                                                    lineHeight: '1.3'
                                                }}>
                                                    {category.name}
                                                </h3>
                                                <p style={{
                                                    margin: 0,
                                                    fontSize: '14px',
                                                    opacity: 0.9,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px'
                                                }}>
                                                    <Leaf style={{ width: '14px', height: '14px' }} />
                                                    Solutions Durables
                                                </p>
                                            </div>
                                            <div style={{ marginLeft: '16px' }}>
                                                {category.icon}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Card Body */}
                                    <div style={{ padding: '20px' }}>
                                        <p style={{
                                            margin: '0 0 16px 0',
                                            fontSize: '14px',
                                            color: '#6b7280',
                                            lineHeight: '1.5'
                                        }}>
                                            {category.description}
                                        </p>
                                        
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-end'
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                color: '#3b82f6',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                gap: '6px'
                                            }}>
                                                <span>Voir plus</span>
                                                <ChevronRight style={{ width: '16px', height: '16px' }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* No Results */}
                        {filteredCategories.length === 0 && (
                            <div style={{ 
                                padding: '40px', 
                                textAlign: 'center', 
                                color: '#64748b',
                                borderTop: '1px solid rgba(30, 64, 175, 0.05)'
                            }}>
                                <Leaf style={{ width: '48px', height: '48px', margin: '0 auto 16px', opacity: 0.5 }} />
                                <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>
                                    Aucune catégorie trouvée
                                </p>
                                <p style={{ fontSize: '14px' }}>
                                    Essayez de modifier vos critères de recherche ou filtres.
                                </p>
                            </div>
                        )}

                        {/* Quick Stats Footer */}
                        {filteredCategories.length > 0 && (
                            <div style={{
                                padding: '16px 20px',
                                backgroundColor: '#f8fafc',
                                borderTop: '1px solid #e5e7eb',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <div style={{ display: 'flex', gap: '24px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <Leaf style={{ width: '16px', height: '16px', color: '#059669' }} />
                                        <span style={{ fontSize: '14px', color: '#374151' }}>
                                            {filteredCategories.length} Catégories
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <Package style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                        <span style={{ fontSize: '14px', color: '#374151' }}>
                                            Solutions Durables
                                        </span>
                                    </div>
                                </div>
                                
                                <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                    Dernière mise à jour: {new Date().toLocaleTimeString('fr-FR')}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Notifications Container */}
                {notifications.length > 0 && (
                    <div style={{
                        position: 'fixed',
                        top: '20px',
                        right: '20px',
                        zIndex: 9999,
                        pointerEvents: 'none'
                    }}>
                        <div style={{ pointerEvents: 'auto' }}>
                            {notifications.map(notification => (
                                <NotificationItem
                                    key={notification.id}
                                    notification={notification}
                                    onRemove={removeNotification}
                                />
                            ))}
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
};

export default SustainableSolutionsPage;